import { useEffect, useState } from 'react';
import type { DailyRapSheet, DailyRapSheetProvider, LoadState } from './model';

export function useDailyRapSheet(provider: DailyRapSheetProvider, refreshKey = 0) {
  const [state, setState] = useState<LoadState>('loading');
  const [data, setData] = useState<DailyRapSheet | null>(null);

  useEffect(() => {
    let active = true;
    provider.getDailyRapSheet().then((result) => {
      if (!active) return;
      setData(result);
      setState(result ? 'ready' : 'empty');
    }).catch(() => {
      if (active) setState('error');
    });
    return () => { active = false; };
  }, [provider, refreshKey]);

  return { state, data };
}
